/*
 * wangsl
 */
import { BindAll } from 'lodash-decorators'
import { EnumApiShow } from '../../api'
import { AjaxBasics } from '../../helpers/ajaxBasics'
import { $service } from '@xt/client/experimental/request/service'

type QrcodeParams = {
  page: string
  query?: string
  /** 1: 展览小程序  2: UC小程序 */
  appletsType?: 1 | 2
  envVersion?: 'release' | 'trial' | 'develop'
  hyaline?: boolean
}

@BindAll()
export class ControllerShow {
  constructor(protected $ajax: AjaxBasics) {}

  async getShowDetailByShowId(showId: number): Promise<any> {
    return await this.$ajax.get(EnumApiShow.showDetail, { showId })
  }

  // 获取二维码
  async onGetQrcode(params: QrcodeParams) {
    return await $service({
      url: EnumApiShow.appletsQrcode,
      data: params,
      params,
      responseType: 'blob',
      headers: {
        'Content-Type': 'image/jpeg'
      }
    })
  }

  async getQrcodeUrl(params: QrcodeParams) {
    const [_, res] = await this.onGetQrcode(params)
    return window.URL.createObjectURL(res)
  }
}

export default ControllerShow
